import "./style.scss";
import { useState, useEffect} from "react";
import ButtonSelector from "../ButtonSelector";
import useWindowDimensions from "helpers/screen";

const FooterPagination = ({selected, setSelected, numPages}) => {

  const {width} = useWindowDimensions();
  const [elements, setElements] = useState([])
  const [maxNumPages, setMaxNumPages] = useState(9);

  useEffect(() => {
    if(width <= 900) setMaxNumPages(5)
  }, [width])

  useEffect(() => {
    setElements(formElems(selected))
  }, [numPages]);

  useEffect(() => {
    const curSelect = elements[selected];
    if(curSelect ==="..."){
      expend(elements[3] + 1)
    }else if("..." === elements[4] && curSelect >= numPages - 4){
      let elems = ["<"];
      for ( let i = numPages - 9; i <= numPages; i++){
        elems.push(i)
      }
      setElements(elems);
      setSelected(selected => selected + 2)
    }else if(curSelect === "<"){
      minimise(elements[selected + 1] - 2)
    }
  }, [selected])

  const minimise = (startPoint) => {
    if(startPoint > 0) {
      setElements(["<",...formElems(startPoint)])
      setSelected(selected => selected + 1)
    }
    else{ 
      setElements(formElems(startPoint))
      setSelected(0)
    }
  }

  const formElems = (startingPoint) => {
    let elems = [];
    if(numPages < 10){
      for(let i = 0; i < numPages; i++){
        elems.push(i+1)
      }
    }else{
      for(let i = 0; i < 9; i++){
        if(i < 4) elems.push(startingPoint+i+1)
        else if(i == 4) elems.push("...")
        else elems.push(numPages +  i - 8)
      }
    }
    return elems;
  }

  const expend = (startingPoint) => {
    let formedElems = formElems(startingPoint)
    let elems = []
    if(formedElems[0] > 1)  elems = ["<",...formedElems]
    else elems = formedElems
    setSelected(1)
    setElements(elems)
  }
  
  const nextPage = () => {
    if(elements.length >= selected + 1) setSelected(selected => selected + 1)
  }

  const previousPage = () => {
    if(0 < selected - 1){
      setSelected(selected => selected - 1)
    }
  }

  return <div className="footerPagination flex justify-between">
    {/* <div className="previousButton flex disable-select" onClick={() => previousPage()}>
      <ArrowLeft/>
      <p className="Text-sm-m">Previous</p>
    </div> */}

    <ButtonSelector 
      selected={selected}
      onSelect={setSelected}
      items={elements}/>

    {/* <div className="nextButton flex disable-select" onClick={() => nextPage()}>
      <p className="Text-sm-m">Next</p>
      <ArrowRight/>
    </div> */}
  </div>
}

export default FooterPagination;